<ifbp-dashboard-page-shell [page]="page$ | async" [asOfUtc]="(vm$ | async)?.asOfUtc ?? null">
  <ng-container *ngIf="vm$ | async as vm" [ngSwitch]="vm.state">
    <ifbp-conversion-metrics-skeleton *ngSwitchCase="VmState.LOADING"></ifbp-conversion-metrics-skeleton>
    <ifbp-snapshot-error-card *ngSwitchCase="VmState.ERROR" [message]="vm.errorMessage"></ifbp-snapshot-error-card>
    <section class="conversion__cards" *ngSwitchCase="VmState.DATA">
      <ifbp-conversion-rate-card
        class="conversion__card"
        *ngFor="let card of vm.data?.cards; trackBy: trackByCard"
        [vm]="card"
      ></ifbp-conversion-rate-card>
    </section>
  </ng-container>
</ifbp-dashboard-page-shell>
